<template>
  <div class="text-divider">
    <span><slot /></span>
  </div>
</template>

<style scoped>
.text-divider {
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  width: 100%;
}

.text-divider::before,
.text-divider::after {
  content: "";
  flex: 0 1 var(--spacing-xl);
  border-bottom: 1px solid var(--fill-color-grey-light);
}

.text-divider span {
  padding: 0 var(--spacing-xs);
  color: var(--text-color-muted);
  font-size: var(--font-size-small);
}
</style>
